import React from 'react';
import BaseActionForm from '../BaseActionForm';
import { Button } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import './styles.scss'
import { useNavigate, useLocation } from 'react-router-dom'
import BackArrow from './../../assets/BackArrow.svg'

export default function MassUpdate(props) {
    const navigation = useNavigate() // extract navigation prop here 
    const { state } = useLocation();
    return <MassUpdateClass
        {...props}
        dataset={props.choosenDataset ? props.choosenDataset : (state && state.params && state.params.D_dataset)} navigation={navigation}
    /> //pass to your component.
}

class MassUpdateClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            runningOperation: null,
            completeMessage: null,
            newValue: null
        }
    }

    updatingManyColumns = (value) => {
        this.setState({ runningOperation: true });

        let newVal = {
            [this.props.field]: value
        }
        ApiService.updateManyObjects(
            "userDatasetByToken",
            this.props.token,
            this.props.filters || {},
            newVal,
            true).then((response) => {
                if (response.status === "success") {
                    this.setState({
                        runningOperation: false,
                        completeMessage: 'Готово! Обновлено ' + response.modifiedCount + ' записей.'
                    });
                }
                else {
                    this.setState({
                        runningOperation: false,
                        completeMessage: 'Не удалось, попробуйте еще раз.'
                    });
                }
            });
    }

    render() {
        let filterLabels = [];
        if (this.props.filters && (Object.entries(this.props.filters).length > 0)) {
            Object.entries(this.props.filters).forEach((fieldName) => {
                this.props.dataset.fields.forEach((field) => {
                    if (field.name === fieldName[0]) {
                        filterLabels.push("поле «" + field.caption + "»: значение «" + this.props.filters[fieldName[0]]['$regex'] + "»");
                    }
                });
            });
        }

        let fieldCaption = "";
        this.props.dataset.fields.forEach((field) => {
            if (field.name === this.props.field) {
                fieldCaption = field.caption;
            }
        });

        return (
            <div className='twoHalfs'>
                <div id={"MassUpdate"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <div className="headerContainer">
                        {this.props && !this.props.dataset && <img src={BackArrow} className='backArrow' alt='back arrow' onClick={() => this.props.navigation(-1)} />}
                        <div className='titleContainer'><p className="headerMargin">Калькулятор полей</p></div>
                    </div>

                    {this.props && this.props.dataset && <div className="bottomHeaderContainer">
                        <p>{this.props.dataset.name}</p>
                    </div>}

                    <div className="postHeaderContainer textRoboto infoContainer">

                        {(filterLabels.length > 0) ?
                            <div>
                                <p className="textHint">Изменения применятся к {this.props.count} записям, поскольку выбраны фильтры:</p>
                                {filterLabels.map((label, i) => (
                                    <p className="textHint" key={'textHintMap'+i}>- {label}</p>
                                ))}
                            </div>
                            :
                            <p className="textHint">Изменения будут применяться ко всему набору. Если нужно, выберите фильтрами колонок какую-то часть данных.</p>
                        }

                        <p className="textBottom">Задайте значение полю «{fieldCaption}»</p>

                        {(!this.state.completeMessage) && (!this.state.runningOperation) &&
                            <>
                                <input
                                    className={'valueField'}
                                    type={'text'}
                                    onChange={(e) => {
                                        this.setState({ newValue: e.target.value });
                                    }}
                                />
                            </>
                        }

                        {(this.state.runningOperation) &&
                            <p className="textBottom" key='textBottom1'>Процесс начался...</p>
                        }

                        {(this.state.completeMessage) &&
                            <p className="textBottom">{this.state.completeMessage}</p>
                        }
                    </div>
                    {(!this.state.completeMessage) && (!this.state.runningOperation) &&
                        <><Button
                            className='applyInstrument blueBtn'
                            onClick={() => {
                                this.updatingManyColumns(null);
                            }}
                        >Обнулить</Button>
                            <Button
                                className='applyInstrument'
                                style={this.state.newValue ? { opacity: '1' } : { opacity: '0.3', pointerEvents: 'none' }}
                                onClick={() => {
                                    this.updatingManyColumns(this.state.newValue);
                                }}
                            >Заполнить</Button>
                        </>}
                </div>

                <div className='rightHalf'></div>
            </div>
        );
    }
}

